import React, { useState } from "react";
import axios from "axios";
import LMBLoggingDashboard from "../Berende/LMB-LoggingDashboard";

const NieuweBerende = () => {
    const [formData, setFormData] = useState({
        naam: '',
        cleanorg: '',
        berende: false,
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleCheckbox = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.checked
        });
    };

    const Nieuw = async () => {
        const response = await axios.get(`/api/organization/create`, {
        params: {
            name: formData.naam,
            clean: formData.cleanorg,
            isBerende: formData.berende,
        }
        });
    };

    return (
        <div className={"pl-14 pr-14 flex flex-col items-center gap-10 p-2"}>
            <div className="flex w-full h-full justify-center gap-10">
                <dialog id={"loading"} open className={"top-52 z-50 text-center text-9xl p-10 rounded-lg shadow-xl bg-white select-none hidden flex-col gap-10"}>
                    Laden...
                    <h1 className={"text-2xl"}>dit kan even duren</h1>
                </dialog>
                <div className="flex w-2/6 flex-col items-center gap-5 bg-white rounded-md shadow-lg p-8">
                    <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>Maak Een Nieuwe Organisatie</h1>
                    <form onSubmit={Nieuw} id={"form"} className="flex flex-col items-center gap-4 rounded-md justify-center w-full">
                        <div className="w-full flex flex-col gap-1">
                            <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Functionele Bedrijfs Naam</h1>
                            <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="text" placeholder="Bijvoorbeeld jjmderidder" name="naam" value={formData.naam} onChange={handleChange} required/>
                        </div>
                        <div className="w-full flex flex-col gap-1">
                            <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Nette Bedrijfs Naam</h1>
                            <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="text" placeholder="Vul Hier De Nette Bedrijfs Naam In" name="cleanorg" value={formData.cleanorg} onChange={handleChange} required/>
                        </div>
                        <div className="w-full flex gap-1 py-5">
                            <h1 className={"text-gray-600 pl-1 text-xl text-nowrap font-medium"}>Is LMB Logging Account</h1>
                            <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="checkbox" name="berende" checked={formData.berende} onChange={handleCheckbox} required/>
                        </div>
                        <input
                            className="w-fit text-2xl text-center rounded-md py-2 px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"
                            type="submit" value={"Maak Organisatie"}
                        />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NieuweBerende;